import { useContext, useEffect, useState } from 'react';
import LoadTicketHistoryForm from './forms/LoadTicketHistoryForm';
import LazyLoading from '../../../components/LazyLoading';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import useLoadTicketHistoryService from '../../../app/services/hooks/useLoadTicketHistoryService';
import { LoadTicketHistoryDataForm } from '../../../app/models/LoadTicketsHistory';

interface Props {
    loadTicketHistoryId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const LoadTicketHistoryEdit = ({ loadTicketHistoryId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const {
        editLoadTicketHistory,
        updateLoadTicketHistory,
        fetchingHistoryLoadTicketEdit,
        fetchingHistoryLoadTicketUpdate
    } = useLoadTicketHistoryService();

    const [LoadTicketHistory, setLoadTicketHistory] = useState<LoadTicketHistoryDataForm>({
        comment: ''
    });

    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        editHistory();
    }, [loadTicketHistoryId]);

    const editHistory = () => {
        if (showLoading) showLoading('loading', 'Cargando información de historial...');
        editLoadTicketHistory(loadTicketHistoryId, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setLoadTicketHistory(response.data.load_ticket_history);
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onCancel) onCancel();
            }
        });
    };

    const updateHistory = () => {
        if (showLoading) showLoading('loading', 'Actualizando información de historial...');
        updateLoadTicketHistory(loadTicketHistoryId, LoadTicketHistory, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingHistoryLoadTicketEdit ? (
        <LazyLoading height={300} />
    ) : (
        <>
            <div className="row">
                <div className="col-12">
                    <LoadTicketHistoryForm
                        loadTicketHistoryDataForm={LoadTicketHistory}
                        setLoadTicketHistoryDataForm={setLoadTicketHistory}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm
                        callbackCancel={cancel}
                        locked={fetchingHistoryLoadTicketUpdate}
                    />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm
                        callbackSave={updateHistory}
                        locked={fetchingHistoryLoadTicketUpdate}
                    />
                </div>
            </div>
        </>
    );
};

export default LoadTicketHistoryEdit;
